import styled from "styled-components";

export const ProgressBarLine = styled.div`
  display: none;
  @media (max-width: 499px) {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: #515151;
    z-index: 1;
  }
`;

export const TrackProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--white-secondary);
  z-index: 1;

  &::before {
    content: "";
    width: var(--progress, 0%);
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background: var(--orange-primary);
    box-shadow: 0px 0px 7px 0px rgba(255, 0, 123, 1);
    z-index: 1;
  }
`;
